/* This file is auto-generated, manual edits in this file will be overwritten! */

export const i18nKeys = {
  MailSubject: {
    RecoveryPassword: 'MailSubject.RecoveryPassword',
  },
  a11y: {
    ariaLabel: {
      menu: 'a11y.ariaLabel.menu',
    },
  },
  bl: {
    brps: {
      label: 'bl.brps.label',
      url: 'bl.brps.url',
    },
    general: {
      serviceVouchers: {
        customerWebsite: {
          url: 'bl.general.serviceVouchers.customerWebsite.url',
        },
        providerWebsite: {
          url: 'bl.general.serviceVouchers.providerWebsite.url',
        },
      },
      url: {
        complaint: 'bl.general.url.complaint',
        contactAProvider: 'bl.general.url.contactAProvider',
        contactUs: 'bl.general.url.contactUs',
        cookies: 'bl.general.url.cookies',
        faq: 'bl.general.url.faq',
        news: 'bl.general.url.news',
        privacyPolicy: 'bl.general.url.privacyPolicy',
        question: 'bl.general.url.question',
        termsAndConditions: 'bl.general.url.termsAndConditions',
      },
    },
    siteBar: {
      title: 'bl.siteBar.title',
    },
  },
  brussels: {
    footer: {
      title: 'brussels.footer.title',
    },
    header: {
      regionName: 'brussels.header.regionName',
    },
  },
  error: {
    idpAccountErrorDecommissionedTitle:
      'error.idpAccountErrorDecommissionedTitle',
    idpAccountErrorDecommissioned: 'error.idpAccountErrorDecommissioned',
    ipdDefaultErrorTitle: 'error.ipdDefaultErrorTitle',
    ipdDefaultError: 'error.ipdDefaultError',
    idpConfigErrorDescription: 'error.idpConfigErrorDescription',
    idpConfigErrorDescriptionProvider:
      'error.idpConfigErrorDescriptionProvider',
    idpConfigErrorTitle: 'error.idpConfigErrorTitle',
    loginErrorAccountBlockedTitle: 'error.loginErrorAccountBlockedTitle',
    loginErrorAccountBlocked: 'error.loginErrorAccountBlocked',
    loginErrorAccountDisabledTitle: 'error.loginErrorAccountDisabledTitle',
    loginErrorAccountDisabled: 'error.loginErrorAccountDisabled',
    loginErrorInvalidUsernamePassword:
      'error.loginErrorInvalidUsernamePassword',
    loginErrorNotAllowed: 'error.loginErrorNotAllowed',
    loginErrorTitle: 'error.loginErrorTitle',
    loginErrorUserNotFound: 'error.loginErrorUserNotFound',
    loginErrorWrongTenant: 'error.loginErrorWrongTenant',
    loginErrorUserNotBelgian: 'error.loginErrorUserNotBelgian',
    loginUnknownError: 'error.loginUnknownError',
    logoutErrorDescription: 'error.logoutErrorDescription',
    logoutErrorTitle: 'error.logoutErrorTitle',
    sessionExpiredFor2FADescription: 'error.sessionExpiredFor2FADescription',
    sessionExpiredFor2FATitle: 'error.sessionExpiredFor2FATitle',
    validationCodeFor2FADescription: 'error.validationCodeFor2FADescription',
    validationCodeFor2FATitle: 'error.validationCodeFor2FATitle',
    workerLoginErrorAccountBlocked: 'error.workerLoginErrorAccountBlocked',
    workerLoginErrorAccountDisabled: 'error.workerLoginErrorAccountDisabled',
  },
  errors: {
    form: {
      email: 'errors.form.email',
      maxLength: 'errors.form.maxLength',
      maxValue: 'errors.form.maxValue',
      minLength: 'errors.form.minLength',
      minValue: 'errors.form.minValue',
      password: 'errors.form.password',
      passwordRequired: 'errors.form.passwordRequired',
      required: 'errors.form.required',
      usernameRequired: 'errors.form.usernameRequired',
    },
  },
  flanders: {
    footer: {
      overRegionWebsite: 'flanders.footer.overRegionWebsite',
      title: 'flanders.footer.title',
    },
    header: {
      regionName: 'flanders.header.regionName',
    },
  },
  footer: {
    accessibility: 'footer.accessibility',
    appnameTitle: 'footer.appnameTitle',
    cookieManagement: 'footer.cookieManagement',
    copyright: 'footer.copyright',
    cta: {
      complaint: {
        label: 'footer.cta.complaint.label',
        url: 'footer.cta.complaint.url',
      },
      question: {
        label: 'footer.cta.question.label',
        url: 'footer.cta.question.url',
      },
    },
    disclaimer: 'footer.disclaimer',
    foremLogoAlt: 'footer.foremLogoAlt',
    nav: {
      cookies: {
        label: 'footer.nav.cookies.label',
      },
      news: {
        label: 'footer.nav.news.label',
      },
      pp: {
        label: 'footer.nav.pp.label',
      },
      tc: {
        label: 'footer.nav.tc.label',
      },
    },
    publishedBy: 'footer.publishedBy',
    subtitle: 'footer.subtitle',
    title: 'footer.title',
  },
  general: {
    daysCount: 'general.daysCount',
    goToNextPagePagination: 'general.goToNextPagePagination',
    goToPreviousPagePagination: 'general.goToPreviousPagePagination',
    monthCount: 'general.monthCount',
    nextPagination: 'general.nextPagination',
    ofPagination: 'general.ofPagination',
    pageLoading: 'general.pageLoading',
    showMorePagination: 'general.showMorePagination',
    showPassword: 'general.showPassword',
  },
  header: {
    appNameTitle: 'header.appNameTitle',
    appNameTitleWithRegion: 'header.appNameTitleWithRegion',
    redirectToRegionHomePage: 'header.redirectToRegionHomePage',
    support: {
      contactList: {
        callus: {
          title: 'header.support.contactList.callus.title',
        },
        contactus: {
          description: 'header.support.contactList.contactus.description',
        },
        findProvider: {
          title: 'header.support.contactList.findProvider.title',
        },
        pass: {
          title: 'header.support.contactList.pass.title',
        },
      },
      subtitle: 'header.support.subtitle',
      title: 'header.support.title',
    },
  },
  idm: {
    form: {
      PostalCode: 'idm.form.PostalCode',
      companyNameOrNumber: 'idm.form.companyNameOrNumber',
      cta: 'idm.form.cta',
      reset: 'idm.form.reset',
      title: 'idm.form.title',
    },
    headquarter: {
      title: 'idm.headquarter.title',
    },
    introduction: 'idm.introduction',
    results: {
      alert: {
        noEnterprisesAssigned: {
          description: 'idm.results.alert.noEnterprisesAssigned.description',
          title: 'idm.results.alert.noEnterprisesAssigned.title',
        },
      },
      card: {
        addFavorite: 'idm.results.card.addFavorite',
        cta: 'idm.results.card.cta',
        removeFavorite: 'idm.results.card.removeFavorite',
      },
      cta: {
        less: 'idm.results.cta.less',
        more: 'idm.results.cta.more',
      },
      intro: 'idm.results.intro',
      noResults: 'idm.results.noResults',
      title: 'idm.results.title',
    },
    timer: {
      active: 'idm.timer.active',
      expired: 'idm.timer.expired',
    },
    title: 'idm.title',
  },
  idp: {
    EmailField: 'idp.EmailField',
    EmailadressField: 'idp.EmailadressField',
    introduction: {
      BE_BRU: 'idp.introduction.BE_BRU',
      BE_WAL: 'idp.introduction.BE_WAL',
      BE_VLG: 'idp.introduction.BE_VLG',
    },
    LogWithBurgerProfileButton: 'idp.LogWithBurgerProfileButton',
    LogWithBurgerProfileTitle: 'idp.LogWithBurgerProfileTitle',
    LogWithBurgerProfileTitleProvider: 'idp.LogWithBurgerProfileTitleProvider',
    LogWithEmailPasswordTitle: 'idp.LogWithEmailPasswordTitle',
    MainTitle: 'idp.MainTitle',
    MainTitleProvider: 'idp.MainTitleProvider',
    PasswordField: 'idp.PasswordField',
    requiredLegend: 'idp.requiredLegend',
    legacyLoginWarning: {
      itsme: 'idp.legacyLoginWarning.itsme',
      paradigm: 'idp.legacyLoginWarning.paradigm',
    },
    authorizationNumber: 'idp.authorizationNumber',
    authorizationNumberProvider: 'idp.authorizationNumberProvider',
    backButton: 'idp.backButton',
    changePassword: 'idp.changePassword',
    confirmNewPassword: 'idp.confirmNewPassword',
    connectionButton: 'idp.connectionButton',
    connectWithPluxee: 'idp.connectWithPluxee',
    cta: {
      connectToApplication: 'idp.cta.connectToApplication',
      forgotPassword: 'idp.cta.forgotPassword',
      loginWithProvider: {
        itsme: 'idp.cta.loginWithProvider.itsme',
        paradigm: 'idp.cta.loginWithProvider.paradigm',
      },
    },
    desactivationApprovalMessage: 'idp.desactivationApprovalMessage',
    desactivationConfirmationButton: 'idp.desactivationConfirmationButton',
    desactivationCanceledMessage: 'idp.desactivationCanceledMessage',
    linkAccountMessage: {
      BE_WAL: 'idp.linkAccountMessage.BE_WAL',
    },
    skipLinkAccount: {
      BE_WAL: 'idp.skipLinkAccount.BE_WAL',
    },
    confirmLinkAccount: {
      BE_WAL: 'idp.confirmLinkAccount.BE_WAL',
    },
    linkAccountTitle: {
      BE_WAL: 'idp.linkAccountTitle.BE_WAL',
    },
    tooltip: {
      itsme: {
        title: 'idp.tooltip.itsme.title',
        description: 'idp.tooltip.itsme.description',
        cta: 'idp.tooltip.itsme.cta',
        ctaLink: 'idp.tooltip.itsme.ctaLink',
      },
    },
    or: 'idp.or',
    externalProvider: {
      paradigm: 'idp.externalProvider.paradigm',
    },
    equalPassword: 'idp.equalPassword',
    forgotPassword: {
      cta: {
        resetPassword: 'idp.forgotPassword.cta.resetPassword',
      },
      description: 'idp.forgotPassword.description',
      message: 'idp.forgotPassword.message',
      radioBtn: {
        resetPassword: 'idp.forgotPassword.radioBtn.resetPassword',
        sendLoginCredentials:
          'idp.forgotPassword.radioBtn.sendLoginCredentials',
      },
      title: 'idp.forgotPassword.title',
    },
    forgotPasswordLink: 'idp.forgotPasswordLink',
    logoutMessage: 'idp.logoutMessage',
    newPassword: 'idp.newPassword',
    noAccountYet: 'idp.noAccountYet',
    passwordChange: 'idp.passwordChange',
    passwordChangeErrorMessage: 'idp.passwordChangeErrorMessage',
    passwordChangeSuccessMessage: 'idp.passwordChangeSuccessMessage',
    passwordRecovery: 'idp.passwordRecovery',
    passwordRecoveryErrorMessage: 'idp.passwordRecoveryErrorMessage',
    passwordRecoveryIntro: 'idp.passwordRecoveryIntro',
    passwordRecoveryIntroProvider: 'idp.passwordRecoveryIntroProvider',
    passwordRecoveryMatchingError: 'idp.passwordRecoveryMatchingError',
    passwordRecoverySuccessMessage: 'idp.passwordRecoverySuccessMessage',
    passwordRule1: 'idp.passwordRule1',
    passwordRule2: 'idp.passwordRule2',
    passwordRule3: 'idp.passwordRule3',
    passwordRule4: 'idp.passwordRule4',
    passwordRulesIntro: 'idp.passwordRulesIntro',
    registerHereLink: 'idp.registerHereLink',
    sendRequest: 'idp.sendRequest',
    tokenInvalidMessage: 'idp.tokenInvalidMessage',
    userNameField: 'idp.userNameField',
    worker: {
      MainSubTitle: 'idp.worker.MainSubTitle',
      MainTitle: 'idp.worker.MainTitle',
      authenticationCodeExplanationLabel:
        'idp.worker.authenticationCodeExplanationLabel',
      authenticationCodeLabel: 'idp.worker.authenticationCodeLabel',
      authenticationCodeTitle: 'idp.worker.authenticationCodeTitle',
      logWithEmailPasswordSharingInfoWarning:
        'idp.worker.logWithEmailPasswordSharingInfoWarning',
    },
  },
  navigation: {
    title: 'navigation.title',
  },
  pageTitle: {
    general: 'pageTitle.general',
    login: 'pageTitle.login',
    passwordChange: 'pageTitle.passwordChange',
    passwordRecovery: 'pageTitle.passwordRecovery',
  },
  vl: {
    general: {
      serviceVouchers: {
        customerWebsite: {
          url: 'vl.general.serviceVouchers.customerWebsite.url',
        },
        providerWebsite: {
          url: 'vl.general.serviceVouchers.providerWebsite.url',
        },
      },
      url: {
        complaint: 'vl.general.url.complaint',
        contactAProvider: 'vl.general.url.contactAProvider',
        contactUs: 'vl.general.url.contactUs',
        cookies: 'vl.general.url.cookies',
        faq: 'vl.general.url.faq',
        news: 'vl.general.url.news',
        privacyPolicy: 'vl.general.url.privacyPolicy',
        question: 'vl.general.url.question',
        termsAndConditions: 'vl.general.url.termsAndConditions',
      },
    },
  },
  wl: {
    brps: {
      label: 'wl.brps.label',
      url: 'wl.brps.url',
    },
    general: {
      serviceVouchers: {
        customerWebsite: {
          url: 'wl.general.serviceVouchers.customerWebsite.url',
        },
        providerWebsite: {
          url: 'wl.general.serviceVouchers.providerWebsite.url',
        },
      },
      url: {
        complaint: 'wl.general.url.complaint',
        contactAProvider: 'wl.general.url.contactAProvider',
        contactUs: 'wl.general.url.contactUs',
        cookies: 'wl.general.url.cookies',
        faq: 'wl.general.url.faq',
        news: 'wl.general.url.news',
        privacyPolicy: 'wl.general.url.privacyPolicy',
        question: 'wl.general.url.question',
        termsAndConditions: 'wl.general.url.termsAndConditions',
      },
    },
    siteBar: {
      title: 'wl.siteBar.title',
    },
  },
};
